import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { initialize, LDClient, LDFlagSet } from 'launchdarkly-js-client-sdk';
import { Subject } from 'rxjs';
import { selectAppFeatureFlagClientKey, State } from '../../state';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  ldClient: LDClient;
  flags: LDFlagSet;
  flagChange = new Subject<object>();

  constructor(private readonly store: Store<State>) {
    this.flags = {
    };

    const context = this;
    this.store.select(selectAppFeatureFlagClientKey).subscribe(clientKey => {
      this.ldClient = initialize(clientKey, {
        key: 'applicant',
        anonymous: true
      });

      this.ldClient.on('ready', function() {
        context.setFlags();
      });

      this.ldClient.on('change', (flags) => {
        for (const flagKey in this.flags) {
          if (this.flags.hasOwnProperty(flagKey)) {
            this.checkAndUpdateFeatureFlag(flags, flagKey);
          }
        }

        this.flagChange.next(this.flags);
      });
    });
  }

  setFlags() {
    this.flags = this.ldClient.allFlags();
    this.flagChange.next(this.flags);
  }

  checkAndUpdateFeatureFlag(flags: any, key: string) {
    if (flags[key] !== undefined) {
      this.flags[key] = flags[key].current;
    }
  }
}
